import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginTop:"50px",
    marginBottom:"100px"
  },
  container:{
    padding:"10px",
    borderRadius:"10px"
  },
  wrapper: {
    paddingLeft: 4,
    paddingRight: 4,
    marginBottom: 15,
  },
  card: {
    height: "100%",
    borderRadius: 5,
  },
  medium: {
    width: 60,
    height: 60,
    margin: "10px",
  },
  large: {
    width: 80,
    height: 80,
  },
  wrapImg:{
      display:"flex",
      justifyContent:"center"
  },
  wrapScroll: {
    display: "flex",
    overflowX: "auto",
    flexWrap: "nowrap",
  },
}));

export default useStyles;